<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <section class="content">
        <ngx-spinner size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="false">
            <p style="color: white"> Loading... </p>
        </ngx-spinner>
        <div class="container-fluid">
            <div class="card  card-info">
                <div class="card-header">
                    <div class="card-title">
                        <i class="fa fa-file-excel-o"></i>โยกย้ายคิว {{zone}}
                    </div>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" (click)="LoaddataQ();"><i
                                class="fas fa-sync"></i></button>
                        <!--<button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>-->
                    </div>
                </div>

                <div class="row justify-content-md-center">
                    <div class="row col-7 text-center">
                        <div class="col"></div>
                        <ul class="nav nav-pills nav-fill mb-3" id="vert-tabs-tab" role="tablist"
                            aria-orientation="horizontal">
                            <li class="nav-item " role="presentation">
                                <a class="nav-item nav-link" id="tabs-tab1" (click)="setDataSet(1);" data-toggle="pill"
                                    style="font-size: 120%">
                                    คิวล็อก <span class="badge bg-warning">{{ dataApi1.length }}</span></a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-item nav-link" id="tabs-tab2" (click)="setDataSet(3);" data-toggle="pill"
                                    style="font-size: 120%">
                                    คิวรถตัด <span class="badge bg-warning">{{ dataApi3.length }}</span></a>
                            </li>
                        </ul>
                        <div class="col"></div>
                    </div>

                    <div class="row col-8 text-center" *ngIf="dataApi0.length>0">
                        <div class="col"></div>
                        <div class="row col-8" [formGroup]="FormCutGroup">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="ค้นหา" formControlName="txtSearch">
                            </div>
                        </div>
                        <div class="col"></div>
                    </div>
                    <div class="col col-lg-10">
                        <div class="card-body table-responsive p-2" style="height: 650px">
                            <table #tb_data class="table table-hover table-head-fixed text-nowrap" style="width:100%">
                                <thead>
                                    <tr class="headText text-primary">
                                        <th style="text-align:center; width:15%">ลำดับ</th>
                                        <th style="text-align:center; width:15%">คิวที่</th>
                                        <th style="text-align:center; width:20%">คิวโซน</th>
                                        <th style="text-align:center; width:25%">กลุ่มคิวปัจจุบัน</th>
                                        <th style="text-align:center; width:25%">กลุ่มเจ้าของคิว</th>
                                        <!--<th style="text-align:center">link</th>-->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let item of dataApi0 | filter:FormCutGroup.value.txtSearch ; let i = index;">
                                        <td style="text-align:center">{{i+1}}</td>
                                        <td style="text-align:center;"><span style="font-size: 95%" class="badge"
                                                [ngClass]="item.truck_type =='S' ? 'bg-info': '' || item.truck_type =='B' ? 'bg-success' :''">
                                                {{item.truck_type}}.{{ item.q_id | number}}</span></td>
                                        <td style="text-align:center">{{item.supzone}}</td>
                                        <td style="text-align:center">{{item.groupcode}}
                                            <a class='far fa-edit' style='font-size:24;color:red'
                                                (click)="openeditcut(item.q_id,item.groupcode);" *ngIf="userlevel==15">
                                            </a>
                                        </td>
                                        <td style="text-align:center">{{item.groupcodeOld}}
                                            <a class='far fa-edit' style='font-size:24;color:red'
                                                (click)="EditRegroup(item.q_id);"
                                                *ngIf="item.groupcodeOld!=item.groupcode"></a>
                                        </td>
                                        <!--<td style="text-align:center">
                                            <button class="btn btn-outline-success" (click)="Loaddata0(item.name,item.link_api+item.and_link);"><i class="far fa-file-excel">                                                    
                                            </i> Download </button>
                                        </td>-->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal กลุ่มตัด -->
        <div class="modal fade" id="editcut" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-primary">
                        <h5 class="modal-title" id="exampleModalLabel">แก้ไขกลุ่มตัด</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body" [formGroup]="FormCutGroup">
                        <p>กลุ่มตัด : <input type="text" class="form-control" value="{{oldgroup}}" disabled>
                            <!--<input type="text"  class="form-control"  list="cutgroup"  value="{{oldgroup}}" formControlName="groupcodeedit" placeholder="กรอกข้อมูลค้นหาแล้วกดเลือกจึงจะบันทึก">-->
                            <select class="form-select" formControlName="groupcodeedit">
                                <option [ngValue]="'CT'" selected>CT : คืนคิวส่วนกลาง</option>
                                <option *ngFor="let item of groupCodeS" [ngValue]="item.groupcode">{{item.groupcode}} :
                                    {{item.h_fmname}}</option>
                            </select>
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal"
                            (click)="Editgroupandtime();">บันทึกรายการ</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<app-footer></app-footer>